import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { Box, FormControlLabel, FormHelperText, TableBody, TableCell, TableRow, Typography } from '@material-ui/core';
import CurrencyFormat from 'react-currency-format';
import Dialog from '../../../../commonModules/interface/Dialog';
import InputText from '../../../../commonModules/interface/form-input-inline';
import Photos from '../../../../commonModules/interface/input-files';
import { TableLayout } from '../containers/Layout';
import { toast } from 'react-toastify';

class FormCredit extends Component {
    state = { 
        amount:"",
        ref: "",
        credit_files: null,
        view: "form",
        errors: {
            amount: ""
        }
    }
    handleChange = async  (e) => {  
        const field = e.target.name
        const value = e.target.value
        console.log({field, value})
        const floatFields = [
            "amount",
        ]
        const regexFloat = /^[+]?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        
        if(floatFields.includes(field)){
            if(value === "" || regexFloat.test(value)){// update value only if its a int || float
                this.setState({ [field]: value })
            }
        } else {
            this.setState({
                [field] : value
            })
        }
    }
    validate = () => {
        let required = ["amount", "credit_files", "ref"]
        let errors = {}
        let noErrors = true
        let view = "confirm"
        
        required.forEach( field => {
            if(isEmpty(this.state[field])){
                noErrors = false
                view = "form"
                errors[field] = "Veuillez remplir ce champ"
            }
        })
        
        this.setState({
            view,
            noErrors,
            errors
        })
    }
    handleSubmit = async () => {
        let data = {
            amount: parseFloat(this.state.amount),
            ref: this.state.ref,
            sale_id: this.props.sale.id,
            credit_files: this.state.credit_files,
        }
        await this.props.createSaleCredit(data)
        if(this.props.STATE.credits.error){
            console.log("ERROR", this.props.STATE.credits.error);
            
            toast.error( this.props.STATE.credits.error)
        } else{
            console.log("fetched");
            //success 
            
            toast.info("Le paiement a été enregistré avec succès")
            this.props.closePopUp()
        }
    }
    setFiles = (list) => {
        console.log("[INFO] SETFILES", list);
        
        this.setState({
            credit_files:list
        })
    }
    render() {
        const { client, sale } = this.props;
        const { view } = this.state;
        let displayFiles = []
        if (view === "confirm" && !isEmpty(this.state.credit_files) ) {
            displayFiles = this.state.credit_files.map(file => (file.filename))
        }
        const fieldList = [
            
            {name: "client_lastname", label: "Nom", display: client.client_lastname},
            {name: "client_firstname", label: "Prénom", display: client.client_firstname},
            {name: "client_address", label: "Adresse", display: client.client_address},
            {name: "client_city", label: "Ville", display: client.client_city},
            // {name: "client_country", label: "Pays", display: client.client_country},
            // {name: "client_tel", label: "Téléphone", display: client.client_tel},
            // {name: "client_email", label: "Email", display: client.client_email},
            {name: "space"},
            {name: "credit_ref", label:"Référence", display: this.state.ref },
            {name: "amount", label:"Montant", display:<CurrencyFormat value={this.state.amount} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "credit_files", label:"Documents", display: displayFiles.join(" | ") },
            {name: "space"},
            {name: "nature", label: "Nature", display: sale.nature},
            {name: "Date de facturation", label: "Date de facturation", display: new Date(sale.date).toLocaleDateString("fr-FR")},

        ]       

        return (
            <Dialog 
                block={true}
                close={this.props.closePopUp}
                title={view === "form" ? `Nouveau paiement pour ${client.client_lastname} ${client.client_firstname}` : "Résumé"}
                submitAction={view === "form" ? this.validate : this.handleSubmit}
                disabledSubmit={this.props.STATE.credits.fetching}
            >
                {view === "form" &&
                    <Box>
                        {/* <Typography>Reste dû : {sale.total_price - total_payed}</Typography> */}
                        <InputText
                            name="amount"
                            value={this.state.amount}
                            onChange={this.handleChange}
                            type="number"
                            title="Montant"
                            error={this.state.errors.amount}
                        />
                        <InputText
                            name="ref"
                            value={this.state.ref}
                            onChange={this.handleChange}
                            title="Référence"
                            error={this.state.errors.ref}
                        />
                        <Box p={1}>
                            <Typography htmlFor="credit_files" variant="body2">Documents</Typography>
                            <Photos
                                photoList={this.setFiles} 
                                photos={this.state.credit_files === null ? [] : this.state.credit_files } 
                                file 
                            />
                            <FormHelperText>{this.state.errors.credit_files}</FormHelperText>
                        </Box>
                    </Box>
                }
                {view === "confirm" &&
                    <TableLayout>
                        <TableBody>
                        {fieldList.map( field => {
                            if (field.name === "space"){
                                return <TableRow><TableCell colSpan={4}></TableCell></TableRow>
                            } else {
                                return (
                                    <TableRow>
                                        <TableCell>{field.label}</TableCell>
                                        <TableCell >{field.display}</TableCell>
                                        <TableCell colSpan={2}></TableCell>
                                    </TableRow>
                                )
                            }
                        }) }                            
                        </TableBody>
                    </TableLayout>
                }
            </Dialog>
        );
    }
}

export default FormCredit;